export const getCanonicalPath = (asPath: string): string => {
  return asPath.split('?')[0];
};
